// Utility to check if perkara exists in inbois or lejar for a given no_akaun
export async function perkaraExists(no_akaun, perkara) {
  // Check inbois
  let existsInInbois = false;
  let existsInLejar = false;
  try {
    const resInbois = await fetch(`/api/inbois/noakaun/${no_akaun}`);
    if (resInbois.ok) {
      const data = await resInbois.json();
      if (Array.isArray(data.data)) {
        existsInInbois = data.data.some((row) => row.perkara === perkara);
      }
    }
  } catch {}
  try {
    const resLejar = await fetch(`/api/lejar/noakaun/${no_akaun}`);
    if (resLejar.ok) {
      const data = await resLejar.json();
      if (Array.isArray(data.data)) {
        existsInLejar = data.data.some((row) => row.perkara === perkara);
      }
    }
  } catch {}
  return existsInInbois || existsInLejar;
}
